import React, { useState, useEffect } from "react";
import {
  Box,
  Container,
  Paper,
  Tabs,
  Tab,
  Chip,
  Typography,
} from "@mui/material";
import { People } from "@mui/icons-material";
import axios from "axios";
import apiEndpoints from "../../apiconfig";

import Overview from "./Overview";
import FeeStructure from "./FeeStructure";
import Invoices from "./Invoices";
import Payments from "./Payments";
import FeeRequest from "./FeeRequest";
import ExpenseEntry from "./ExpenceEntry";

const AdminFees = () => {
  const [activeTab, setActiveTab] = useState(0);
  const [openInvoiceDialog, setOpenInvoiceDialog] = useState(false);

  const [students, setStudents] = useState([]);
  const [feeItems, setFeeItems] = useState([]);

  const token = localStorage.getItem("token");

  const openCreateInvoice = () => {
    setActiveTab(3);
    setTimeout(() => setOpenInvoiceDialog(true), 150);
  };

  /** ----------- INITIAL LOAD ----------- **/
  useEffect(() => {
    loadStudents();
    loadFeeItems();
  }, []);

  /** FETCH STUDENTS **/
  const loadStudents = async () => {
    try {
      const res = await axios.get(apiEndpoints.student, {
        headers: { Authorization: `Bearer ${token}` },
      });
      console.log("res.data", res.data);
      setStudents(res.data.data);
    } catch (err) {
      console.error("Students Fetch Error:", err);
    }
  };

  /** FETCH FEE STRUCTURE ITEMS **/
  const loadFeeItems = async () => {
    try {
      const headers = { Authorization: `Bearer ${token}` };

      // Load standard
      const std = await axios.get(
        `${apiEndpoints.fee_management}?type=standard`,
        { headers }
      );

      // Load custom
      const custom = await axios.get(
        `${apiEndpoints.fee_management}?type=custom`,
        { headers }
      );

      // Merge with proper type
      const merged = [
        ...std.data.data.map(i => ({ ...i, type: "standard" })),
        ...custom.data.data.map(i => ({ ...i, type: "custom" })),
      ];

      setFeeItems(merged);

    } catch (err) {
      console.log("Fee Fetch Error:", err);
    }
  };

  return (
    <Box
      sx={{
        minHeight: "100vh",
        background: "rgba(255, 255, 255, 0.25)",
        backdropFilter: "blur(10px)",
        border: "1px solid rgba(255, 255, 255, 0.4)",
        boxShadow: "0 8px 32px rgba(0, 0, 0, 0.1)",
      }}
    >
      <Container maxWidth="100%"
        sx={{ py: 4, fontFamily: "Montserrat, sans-serif", minHeight: "100vh" }}>

        {/* HEADER */}
        <Box
          sx={{
            mb: 4,
            position: "relative",
            display: "flex",
            flexWrap:"wrap",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >

          <Box>
            <Typography variant="h4" fontWeight="700" gutterBottom>
             Payment Management
            </Typography>
            <Typography variant="body1" color="text.secondary">
               Manage school fees, invoices, and payments efficiently.
            </Typography>
          </Box>  
          <Chip
            icon={<People />}
            label={`${students.length} Students`}
            color="primary"
            sx={{
              mt:1,
              whiteSpace: "nowrap",
              fontSize: { xs: "12px", sm: "14px" },
              px: { xs: 1, sm: 2 },
            }}
          />
        </Box>

        {/* TABS */}
        <Paper
          elevation={0}
          sx={{
            mb: 3,
            background: "rgba(255, 255, 255, 0.25)",
            backdropFilter: "blur(10px)",
            border: "1px solid rgba(255, 255, 255, 0.4)",
            boxShadow: "0 8px 32px rgba(0, 0, 0, 0.1)",
            borderRadius: 3
          }}
        >
          <Tabs
            value={activeTab}
            onChange={(e, v) => setActiveTab(v)}
            variant="scrollable"
            scrollButtons="auto"
          >
            <Tab label="Overview" />
            <Tab label="Fee Structure" />
            <Tab label="Fee Request" />
            <Tab label="Student Fee Transaction" />
            <Tab label="Expence Manager" />
          </Tabs>
        </Paper>

        {/* TAB CONTENT */}
        {activeTab === 0 && <Overview/>}

        {activeTab === 1 && (
          <FeeStructure
            feeItems={feeItems}
            setFeeItems={setFeeItems}
            refresh={loadFeeItems}
          />
        )}

        {activeTab === 2 && (
          <FeeRequest feeItems={feeItems} />
        )}

        {activeTab === 3 && <Payments />}

        {activeTab === 4 && <ExpenseEntry />}

      </Container>
    </Box>
  );
};

export default AdminFees;
